import { render, staticRenderFns } from "./historyAnalysis.vue?vue&type=template&id=0c2cf2c0&scoped=true&"
import script from "./historyAnalysis.vue?vue&type=script&lang=js&"
export * from "./historyAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./historyAnalysis.vue?vue&type=style&index=0&id=0c2cf2c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2cf2c0",
  null
  
)

export default component.exports